import classnames from 'classnames';
import React, { FunctionComponent } from 'react';

type TagProps = {
    className?: string;
};

const Tag: FunctionComponent<TagProps> = props => {
    return (
        <svg
            className={classnames('dibsIcon', props.className)}
            data-tn={'tag'}
            viewBox="0 0 250 250"
        >
            <path d="M213.6 79.4c0-4.1-1.8-8-4.9-10.8L135.2 3.5c-5.4-4.8-13.6-4.8-19.1 0l-73.4 65c-3.1 2.8-4.9 6.7-4.8 10.8v156.6c0 8 6.4 14.4 14.4 14.4h146.8c8 0 14.4-6.4 14.4-14.4l.1-156.5zM147 96.9c-7 12.6-22.8 17.2-35.4 10.2-12.6-7-17.2-22.8-10.2-35.4 7-12.6 22.9-17.1 35.4-10.2 12.5 6.9 17.1 22.8 10.2 35.4z" />
        </svg>
    );
};
export default Tag;
